var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((this.inputIcons),function(input,i){return _c('v-tooltip',{key:i,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":input.small}},on),[_vm._v(" "+_vm._s(input.iconName)+" ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(input.description))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }